import {type PropsWithChildren, useState} from "react";

import {Prompt} from "../components/Prompt";
import {defaultParams, defaultParamsWithInput} from "../constants/defaults";
import type {IPromptProps} from "../types/IPromptProps";
import {PromptContextProvider} from "./PromptContextProvider";

export const PromptProvider = (props: PropsWithChildren) => {
    const [promptParams, setPromptParams] = useState(defaultParams);

    const setPromptParamsWithDefaults = (newProps: Partial<IPromptProps>) => {
        const defaultProps = newProps.input ? defaultParamsWithInput : defaultParams;
        setPromptParams({...defaultProps, ...newProps});
    };

    return (
        <PromptContextProvider value={{...promptParams, setPromptParamsWithDefaults}}>
            {props.children}
            <Prompt />
        </PromptContextProvider>
    );
};
import {type PropsWithChildren, useState} from "react";

import {Prompt} from "../components/Prompt";
import {defaultParams, defaultParamsWithInput} from "../constants/defaults";
import type {IPromptProps} from "../types/IPromptProps";
import {PromptContextProvider} from "./PromptContextProvider";

export const PromptProvider = (props: PropsWithChildren) => {
    const [promptParams, setPromptParams] = useState(defaultParams);

    const setPromptParamsWithDefaults = (newProps: Partial<IPromptProps>) => {
        const defaultProps = newProps.input ? defaultParamsWithInput : defaultParams;
        setPromptParams({...defaultProps, ...newProps});
    };

    return (
        <PromptContextProvider value={{...promptParams, setPromptParamsWithDefaults}}>
            {props.children}
            <Prompt />
        </PromptContextProvider>
    );
};
